export default __webpack_public_path__ + "static/media/ham.2190e449.png";